import React from 'react'

function Loading() {
  return (
    <div ><img style={{margin:"auto"}} src="https://miro.medium.com/max/1400/1*CsJ05WEGfunYMLGfsT2sXA.gif" alt="" /></div>
  )
}

export default Loading